module.exports = __webpack_public_path__ + "static/media/icon-menu-mobile.54eda417.svg";